var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification is-danger"},[_c('p',{staticClass:"heading has-text-centered has-text-weight-bold"},[_vm._v("This resource is forbidden to access.")])])
}]

export { render, staticRenderFns }